const sySheepAntie = () => import("@/pages/sySheep/sySheepAntie/sySheepAntie");
const sySheepCollar = () =>
  import("@/pages/sySheep/sySheepCollar/sySheepCollar");
const sySheepCollarLog = () =>
  import("@/pages/sySheep/sySheepCollarLog/sySheepCollarLog");
const sySheepHouse = () => import("@/pages/sySheep/sySheepHouse/sySheepHouse");
const sySheepPedigree = () =>
  import("@/pages/sySheep/sySheepPedigree/sySheepPedigree");
const sySheepTag = () => import("@/pages/sySheep/sySheepTag/sySheepTag");
const sySheepTagDraw = () =>
  import("@/pages/sySheep/sySheepTagDraw/sySheepTagDraw");
const sySheepTagLog = () =>
  import("@/pages/sySheep/sySheepTagLog/sySheepTagLog");
const sySheepTupparm = () =>
  import("@/pages/sySheep/sySheepTupparm/sySheepTupparm");

const countYzsl = () => import("@/pages/sySheep/countYzsl/countYzsl");

const sySheepCub = () => import("@/pages/sySheep/sySheepCub/sySheepCub");

// 耳标申请
const sySheepTargApply = () =>
  import("@/pages/sySheep/sySheepTargApply/sySheepTargAppTab");
// 耳标审核
const sySheepTargAuditTab = () =>
  import("@/pages/sySheep/sySheepTargAudit/sySheepTargAuditTab");

const sySheepTargGiveOut = () =>
  import("@/pages/sySheep/sySheepTargGiveOut/sySheepTargGiveOut");

// 养殖品种
const syCompProd = () => import("@/pages/syComp/syCompProd/syCompProd.vue");

//项圈监管端
const sySheepCollerJg = () =>
  import("@/pages/sySheep/sySheepCollar/sySheepCollarJg.vue");

export default [
  {
    path: "/sySheep/sySheepHouse",
    name: "sySheepHouse",
    component: sySheepHouse,
    meta: {
      title: "羊舍管理",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "羊舍管理"],
    },
  },
  {
    path: "/sySheep/sySheepTupparm",
    name: "sySheepTupparm",
    component: sySheepTupparm,
    meta: {
      title: "种羊管理",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "种羊管理"],
    },
  },
  {
    path: "/sySheep/sySheepAntie",
    name: "sySheepAntie",
    component: sySheepAntie,
    meta: {
      title: "防疫记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "防疫记录"],
    },
  },
  {
    path: "/sySheep/sySheepPedigree",
    name: "sySheepPedigree",
    component: sySheepPedigree,
    meta: {
      title: "谱系管理",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "谱系管理"],
    },
  },
  {
    path: "/sySheep/sySheepTag",
    name: "sySheepTag",
    component: sySheepTag,
    meta: {
      title: "耳标管理",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "耳标管理"],
    },
  },
  {
    path: "/sySheep/sySheepTagDraw",
    name: "sySheepTagDraw",
    component: sySheepTagDraw,
    meta: {
      title: "耳标领取记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "耳标领取记录"],
    },
  },
  {
    path: "/sySheep/sySheepTagLog",
    name: "sySheepTagLog",
    component: sySheepTagLog,
    meta: {
      title: "耳标使用记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "耳标使用记录"],
    },
  },
  {
    path: "/sySheep/sySheepTagLog",
    name: "sySheepTagLog",
    component: sySheepTagLog,
    meta: {
      title: "耳标使用记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "耳标使用记录"],
    },
  },
  {
    path: "/sySheep/sySheepCollerJg",
    name: "sySheepCollerJg",
    component: sySheepCollerJg,
    meta: {
      title: "项圈管理",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "项圈管理"],
    },
  },
  {
    path: "/sySheep/sySheepCollar",
    name: "sySheepCollar",
    component: sySheepCollar,
    meta: {
      title: "项圈管理",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "项圈管理"],
    },
  },
  {
    path: "/sySheep/sySheepCollarLog",
    name: "sySheepCollarLog",
    component: sySheepCollarLog,
    meta: {
      title: "项圈定位历史记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "项圈定位历史记录"],
    },
  },
  {
    path: "/sySheep/countYzsl",
    name: "countYzsl",
    component: countYzsl,
    meta: {
      title: "养殖量统计",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "养殖量统计"],
    },
  },

  {
    path: "/sySheep/cub",
    name: "sySheepCub",
    component: sySheepCub,
    meta: {
      title: "幼崽采购记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "幼崽采购记录"],
    },
  },
  {
    path: "/sySheep/targApply",
    name: "sySheepTargApply",
    component: sySheepTargApply,
    meta: {
      title: "耳标申请记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "耳标申请记录"],
    },
  },

  {
    path: "/sySheep/targApply/audit",
    name: "sySheepTargAuditTab",
    component: sySheepTargAuditTab,
    meta: {
      title: "耳标审核记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "耳标审核记录"],
    },
  },
  {
    path: "/sySheep/targGiveOut",
    name: "sySheepTargGiveOut",
    component: sySheepTargGiveOut,
    meta: {
      title: "耳标领取记录",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "耳标领取记录"],
    },
  },

  {
    path: "/syComp/syCompProd",
    name: "syCompProd",
    component: syCompProd,
    meta: {
      title: "养殖品种",
      noCache: true,
      affix: true,
      path: ["羊资源管理", "养殖品种"],
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/sySheep.js